export {
  PrimaryControlsStripExpansionMutePushButton,
  type PrimaryControlsStripExpansionMutePushButtonProps,
} from "#primary-controls-strip-expansion-mute-push-button";
